import MetaTag from "components/Common/Meta-tag"
import React from "react"
import { Container } from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import DatatableTables from "./DatatableTables"

function Store() {
  return (
    <>
      <MetaTag title="All Stores" />

      <div className="page-content">
        <Breadcrumbs title="Dashboard" breadcrumbItem="All Stores" />
        <Container fluid>
          <div className="container-fluid">
            <DatatableTables />
          </div>
        </Container>
      </div>
    </>
  )
}

export default Store
